import { useLocation } from "react-router-dom";
import { Wrench, Droplets, Zap, HardHat, Hammer } from "lucide-react";

const industries = [
  { name: "HVAC", href: "/", icon: Wrench, testid: "industry-hvac" },
  { name: "Plumbers", href: "/plumbers", icon: Droplets, testid: "industry-plumbers" },
  { name: "Electricians", href: "/electricians", icon: Zap, testid: "industry-electricians" },
  { name: "Roofers", href: "/roofers", icon: HardHat, testid: "industry-roofers" },
  { name: "General Contractors", href: "/contractors", icon: Hammer, testid: "industry-contractors" },
];

export default function IndustryStrip() {
  const { pathname } = useLocation();
  return (
    <>
      {/* spacer clearing the fixed 68px header */}
      <div aria-hidden="true" className="h-[68px]" />
      <div
        data-testid="industry-strip"
        className="sticky top-[68px] z-40 border-b border-white/[0.08] bg-[#0B0D10]/90 backdrop-blur-xl"
      >
        <div className="mx-auto flex max-w-7xl items-stretch gap-1 overflow-x-auto px-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:px-8">
          <span className="mr-3 hidden shrink-0 items-center py-3.5 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600 md:flex">
            Who we serve
          </span>
          {industries.map((ind) => {
            const active = pathname === ind.href;
            return (
              <a
                key={ind.href}
                href={ind.href}
                data-testid={ind.testid}
                aria-current={active ? "page" : undefined}
                className={`flex shrink-0 items-center gap-2 border-b-2 px-3 py-3.5 font-mono text-[11px] uppercase tracking-wider transition-colors duration-200 ${
                  active
                    ? "border-[#F25F22] text-[#F25F22]"
                    : "border-transparent text-slate-500 hover:text-slate-100"
                }`}
              >
                <ind.icon className="h-3.5 w-3.5" />
                {ind.name}
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
}
